/**
 * Форматирует ISO дату в формат дд.мм.гггг
 */
export function formatDate(isoDate: string | undefined | null): string {
  if (!isoDate) return ''

  try {
    const date = new Date(isoDate)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()

    return `${day}.${month}.${year}`
  } catch {
    return ''
  }
}

/**
 * Вычисляет возраст по дате рождения
 */
export function calculateAge(birthDate: string | undefined | null): number | null {
  if (!birthDate) return null

  try {
    const birth = new Date(birthDate)
    const today = new Date()

    let age = today.getFullYear() - birth.getFullYear()
    const monthDiff = today.getMonth() - birth.getMonth()

    // Если день рождения ещё не наступил в этом году
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
      age--
    }

    return age >= 0 ? age : null
  } catch {
    return null
  }
}

/**
 * Форматирует возраст для отображения
 */
export function formatAge(birthDate: string | undefined | null): string {
  const age = calculateAge(birthDate)
  if (age === null) return ''

  // Правильное склонение "год/года/лет"
  if (age % 10 === 1 && age % 100 !== 11) {
    return `${age} год`
  } else if (age % 10 >= 2 && age % 10 <= 4 && (age % 100 < 10 || age % 100 >= 20)) {
    return `${age} года`
  } else {
    return `${age} лет`
  }
}
